import {CourseSearchQueryVariables, CourseSearchTriggerType} from '@udemy/react-discovery-units';

export const SEARCH_QUERY_OPTIONS_OVERRIDES: CourseSearchQueryVariables = {
    context: {triggerType: CourseSearchTriggerType.BrowseRoleplay},
};
